const reverse = function (str) {
    var newStr = ''
    var i = str.length
    for (; i >= 0; i--) {
      newStr += str.charAt(i)
    }
    return newStr
}

export function currency (value, discuss = true) {
  var html, _val
  value = Number(value).toFixed(2)
  if (isNaN(value) && discuss) return '面议'
  if (value <= 0 && discuss) return '面议'
  if (isNaN(value)) return ''
  if (value.split('.')[1].substring(1) === 0) {
    value = Number(value).toFixed(1)
  }
  _val = value.split('.')
  html = _val[0]
  let len = html.toString().length
  let j = 0
  let temp = ''
  for (let i = len - 1; i >= 0; i--) {
    j++
    if (j % 3 === 0) {
      temp = temp + html.toString().charAt(i) + ','
    } else {
      temp += html.toString().charAt(i)
    }
  }
  html = reverse(temp)
  if (html.charAt(0) === ',') {
    html = html.substr(1)
  }
  if (html.length > 2 && html.charAt(0) === '-' && html.charAt(1) === ',') {
    html = `-${html.substr(2)}`
  }
  return '￥' + html + '.' + _val[1]
}



export function formatFileSize (size) {
  if (isNaN(size)) return ''
  size = Number(size)
  if (size < 1024) {
    return size.toFixed(0) + ' bytes'
  } else if (size < 1024 * 1024) {
    return (size / 1024.0).toFixed(0) + ' KB'
  } else if (size < 1024 * 1024 * 1024) {
    return (size / 1024.0 / 1024.0).toFixed(1) + ' MB'
  } else {
    return (size / 1024.0 / 1024.0 / 1024.0).toFixed(1) + ' GB'
  }
}

export function initFilters (Vue) {
  Vue.filter('currency', currency)
  Vue.filter('formatFileSize', formatFileSize)   
}



// WEBPACK FOOTER //
// ./src/utils/filters.js